import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function GoogleIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.16 9.19321C17.16 8.59048 17.1059 8.01094 17.0055 7.45457H9V10.7425H13.5746C13.3775 11.805 12.7786 12.7053 11.8784 13.308V15.4407H14.6255C16.2327 13.9609 17.16 11.7819 17.16 9.19321Z"
        fill="#1976D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99997 17.5C11.295 17.5 13.2191 16.7389 14.6254 15.4407L11.8784 13.308C11.1173 13.818 10.1436 14.1193 8.99997 14.1193C6.78611 14.1193 4.91224 12.6241 4.24383 10.615H1.40405V12.8173C2.80269 15.5953 5.67724 17.5 8.99997 17.5Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24387 10.6151C4.07387 10.105 3.97728 9.56028 3.97728 9.00005C3.97728 8.43982 4.07387 7.89505 4.24387 7.38505V5.18277H1.40409C0.82841 6.33027 0.5 7.62846 0.5 9.00005C0.5 10.3716 0.82841 11.6698 1.40409 12.8173L4.24387 10.6151Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99997 3.88072C10.2479 3.88072 11.3684 4.30958 12.2493 5.15186L14.6873 2.7139C13.2152 1.3423 11.2911 0.500031 8.99997 0.500031C5.67724 0.500031 2.80269 2.40481 1.40405 5.18277L4.24383 7.38504C4.91224 5.37595 6.78611 3.88072 8.99997 3.88072Z"
        fill="#EA4335"
      />
    </SvgIcon>
  );
}

export default GoogleIcon;
